//@flow
import { connect } from 'react-redux';
import NewPaymentMeanPage from '../../../components/payments/NewPaymentMeanPage/NewPaymentMeanPage.container';
import { addPaymentMeanDuringOrderSim } from '../../../modules/Payment';

const mapStateToProps = state => ({
  cardRegistrationIssuePage: 'cardRegistrationIssueDuringSignUp',
});

const mapDispatchToProps = {
  addPaymentMean: addPaymentMeanDuringOrderSim,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPaymentMeanPage);
